import React from 'react';

const Home = () => (
    <div className="main-content">
        <h1 className="main-title"> Welcome to the Journey </h1>
    </div>
);

export default Home;